import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// Bootstrap 5 JS — enables data-bs-toggle="modal|collapse|dropdown|tab" etc.
// without requiring every legacy bit of markup to be rewritten as
// react-bootstrap. Theme stylesheets are loaded via index.html.
import 'bootstrap';
import { App } from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
